import { useTranslation } from 'react-i18next';

import { Field, Form, TextArea } from '@/components';
import { nullableStringSetter } from '@/helpers';

export type RatingFormProps = {
  readonly id: string;
  readonly onSubmit: (data: RatingFormFields) => void;
};

export type RatingFormFields = {
  rating_comments: string | null;
};

export function RatingForm({ id, onSubmit }: RatingFormProps) {
  const { t } = useTranslation(['offers']);
  const textareaMinLength = 100;
  const textareaMaxLength = 4000;

  return (
    <Form<RatingFormFields> id={id} onSubmit={onSubmit} className="px-6">
      {({ formState, register }) => (
        <div className="space-y-6">
          <Field
            id="rating_comments"
            label={t('Rejection comments')}
            error={formState.errors['rating_comments']}
            delay={0}
            classes={{ field: 'space-y-1' }}
          >
            <TextArea
              id="rating_comments"
              color="primary"
              placeholder="Type here..."
              minLength={textareaMinLength}
              maxLength={textareaMaxLength}
              registration={register('rating_comments', {
                required: t('This field is required'),
                setValueAs: nullableStringSetter,
                maxLength: textareaMaxLength,
                minLength: {
                  value: textareaMinLength,
                  message: t('Minimum {{min}} characters', { min: textareaMinLength }),
                },
              })}
            />
          </Field>
        </div>
      )}
    </Form>
  );
}
